<template>
    <h1 class="flex flex-none flex-col items-start text-xl min-w-[130px] w-[130px] max-w-[130px] sm:max-w-none sm:w-auto flex-shrink-0 mr-2 sm:mr-4"
        v-if="props.loading || props.title">
        <div class="flex items-center gap-1">
            <div id="song-title" 
                class="truncate text-sm md:text-xl text-ellipsis max-w-[130px] sm:max-w-none sm:w-auto">
                {{props.title}}
            </div>
            <div v-if="props.showFavorite" 
                 class="cursor-pointer flex-shrink-0 size-6 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full flex items-center justify-center transition-all duration-200"
                 @click="emits('toggleFavorite')">
                <svg xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 24 24" 
                    stroke-width="1.5" 
                    :class="['size-5 transition-colors', props.isFavorite ? 'fill-yellow-400 stroke-yellow-400 hover:fill-yellow-500 hover:stroke-yellow-500' : 'fill-none stroke-gray-400 hover:stroke-gray-600 dark:stroke-gray-500 dark:hover:stroke-gray-300']">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.563.563 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                </svg>
            </div>
        </div>
        <div class="text-xs text-gray-500 dark:text-gray-400 text-nowrap truncate flex items-center gap-1">
            {{props.artistName}}
            <div class="size-4 p-0.5 hover:bg-indigo-100 dark:hover:bg-indigo-900 rounded-full cursor-pointer" 
                @click="emits('artistInfo', props.artistName)">
                <InformationCircleIcon class="size-3 text-indigo-500 transition-all hover:text-indigo-700" />
            </div>
        </div>
    </h1>
    <div v-else role="status" class="flex flex-none min-w-0 my-7 animate-pulse w-[130px] max-w-[130px]"> 
        <div class="flex flex-col justify-center w-full">
            <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-800 w-full mb-2"></div>
            <div class="h-1.5 bg-gray-100 rounded-full dark:bg-gray-800 w-[80%] mb-2"></div>
        </div>
        <span class="sr-only">Loading...</span> 
    </div>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue';
import { InformationCircleIcon } from '@heroicons/vue/24/outline';

const emits = defineEmits(['artistInfo', 'toggleFavorite']);
const props = defineProps({
    loading: {
        type: Boolean,
        required: true
    },
    title: {
        type: String,
        required: true
    },
    artistName: {
        type: String,
        required: true
    },
    isFavorite: {
        type: Boolean,
        default: false
    },
    showFavorite: {
        type: Boolean,
        default: false
    }
})

</script>